import React, { useState } from "react";
import CreateSchedule from "../../components/schedule/createSchedule";
import TableClose from "../../components/schedule/tableClose";
import TableOpen from "../../components/schedule/tableOpen";

const Schedule = () => {
  const [keyFind] = useState("");

  // const handleSearch = (event: any) => {
  //   setKeyFind(event.target.value);
  // };

  return (
    <>
      <div className="container">
        <h3 className="text-start mt-3">จัดการกำหนดการ</h3>
        <div className="row mt-3">
          <div className="col">
            <h3 className="p-3 mb-4 bg-light rounded-4">
              <div className="row">
                {/* <div className="col">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="ค้นหากำหนดการ"
                    aria-label="ค้นหากำหนดการ"
                    onChange={handleSearch}
                  />
                </div> */}
                <div className="col"></div>
                <div className="col-2 d-grid">
                  <CreateSchedule />
                </div>
              </div>
            </h3>
            <h5 className="text-start mt-3">กำหนดการที่เปิดรับเอกสาร</h5>
            {/* //  แยก component // */}
            <TableOpen keyFind={keyFind} />
            <h5 className="text-start mt-5">กำหนดการที่ปิดรับเอกสาร</h5>
            {/* //  แยก component // */}
            <TableClose keyFind={keyFind} />
          </div>
        </div>
      </div>
    </>
  );
};

export default Schedule;
